import { render, staticRenderFns } from "./ParkingConfiguration.vue?vue&type=template&id=5d196fca&scoped=true&"
import script from "./ParkingConfiguration.vue?vue&type=script&lang=js&"
export * from "./ParkingConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ParkingConfiguration.vue?vue&type=style&index=0&id=5d196fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d196fca",
  null
  
)

export default component.exports